import { render, staticRenderFns } from "./PersonalRevenue.vue?vue&type=template&id=53b42c04&scoped=true&"
import script from "./PersonalRevenue.vue?vue&type=script&lang=js&"
export * from "./PersonalRevenue.vue?vue&type=script&lang=js&"
import style0 from "./PersonalRevenue.vue?vue&type=style&index=0&id=53b42c04&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b42c04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAvatar,VCard,VCol,VListItem,VListItemContent,VListItemTitle,VProgressLinear,VRow,VSimpleTable})
